import styled from "@emotion/styled";
import mixins from "theme/mixins";

export const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: relative;
  pointer-events: none;
  cursor: pointer;
`;

export const StyledIframe = styled.iframe`
  border: 0;
  pointer-events: none;
  cursor: pointer;
`;

export const StyledNumber = styled.div`
  ${mixins.fontCoda()};
  font-size: 90%;
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: ${(props) => props.theme.lightBlue};
  color: ${(props) => props.theme.white};
`;
